import axios from "axios";
import moment from "moment";
import config from "../config.js";

export default {
  async auth({ state, commit }, { username, password, rememberMe }) {
    try {
      state.isLoadingClientData = true;
      let params = {
        method: "auth",
        params: {
          username: username,
          password: password,
          rememberMe: rememberMe,
          device: {
            clientType: "browser",
            model: navigator.userAgent,
            platform: navigator.platform,
          },
        },
      };
      const response = await axios.post(state.baseUrl, params).catch((e) => {
        commit("setLoginError", e.response.data.errorMessage);
      });
      if (response) {
        const success = response.data.error === 0;
        commit("setLoginSuccess", success);
        if (success) {
          const token = response.data.token;
          if (token !== null) {
            commit("setToken", token);
          }
          const deviceCid = response.data.deviceCid;
          if (deviceCid !== null) {
            commit("setDeviceCid", deviceCid);
          }
        }
      } else {
        commit("setLoginSuccess", false);
      }
    } catch (e) {
      console.log("auth error");
    } finally {
      state.isLoadingClientData = false;
    }
  },

  async sendRegister(
    { state, commit },
    {
      inn,
      /*passport,*/ name,
      phoneNumber,
      email,
      clientName,
      login,
      contractNumber,
      comments,
    },
  ) {
    try {
      let params = {
        method: "requestAccess",
        params: {
          inn: inn,
          /*passport: passport,*/
          name: name,
          phoneNumber: phoneNumber,
          email: email,
          clientName: clientName,
          login: login,
          contractNumber: contractNumber,
          comments: comments,
          device: {
            clientType: "browser",
            model: navigator.userAgent,
            platform: navigator.platform,
          },
        },
      };
      const response = await axios.post(state.baseUrl, params).catch((e) => {
        commit("setRegisterError", e.response.data.errorMessage);
      });
      if (response) {
        const success = response.data.error === 0;
        commit("setRegisterSuccess", success);
      } else {
        commit("setRegisterSuccess", false);
      }
    } catch (e) {
      console.log("register error");
    }
  },

  async fetchClient({ state, commit }) {
    try {
      let params = {
        method: "getClient",
        params: {},
        deviceCid: state.deviceCid,
      };
      const response = await axios
        .post(state.baseUrl, params, {
          headers: { "IC-token": state.token },
        })
        .catch((e) => {
          let actualDate = null,
            errorMessage = config.client.defaultGetClientErrorMessage;
          if (state.client) {
            actualDate = moment(state.client.actualDate, "YYYY-MM-DD HH:mm:ss");
          }
          const now = moment();
          if (
            !actualDate ||
            now.format("YYYY-MM-DD") !== actualDate.format("YYYY-MM-DD") ||
            (now - actualDate) / 1000 >
              config.client.betweenDatesGlobalError * 60
          ) {
            commit(
              "setGlobalError",
              config.client.defaultGetClientErrorMessage +
                e.response.data.errorMessage,
            );
          } else {
            errorMessage = errorMessage.replace(
              /:/,
              ":вероятно, вы видите устаревшие данные",
            );
            commit("setClientError", errorMessage);
          }
        });
      if (response) {
        const success = response.data.error === 0;
        commit("setClientSuccess", success);
        if (success) {
          const client = response.data.client;
          if (client !== null) {
            client.replace = true;
            commit("setClient", client);
            delete client.replace;
          }
        }
      } else {
        commit("setClientSuccess", false);
      }
    } catch (e) {
      console.log("client error");
    }
  },

  async updateProfile({ state, commit }, { property, value }) {
    let params = {
      method: "updateProfile",
      params: { [property]: value },
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setUpdateError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setUpdateSuccess", success);
    } else {
      commit("setUpdateSuccess", false);
    }
  },

  async paymentPrepare(
    { state, commit },
    { redirectUrl, clnum, contract, sum, system = "sber25-sbp" },
  ) {
    const params = {
      method: "paymentPrepare",
      params: {
        system: system,
        redirectUrl: redirectUrl,
        login: `clnum=${clnum},contractNumber=${contract}`,
        sum: sum,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setPayError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      if (success) {
        commit("setPaymentUrl", response.data.redirectUrl);
        if (response.data.qrId) {
          commit("setQrId", response.data.qrId);
        }
      } else {
        commit("setPayError", response.data.errorMessage);
      }
      commit("setPaySuccess", success);
    } else {
      commit("setPaySuccess", false);
    }
  },

  async paymentStatus(
    { state, commit },
    { system = "sber25-sbp", registerOrderId },
  ) {
    let params = {
      method: "paymentStatus",
      params: {
        system: system,
        registerOrderId: registerOrderId,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios.post(state.baseUrl, params).catch((e) => {
      commit("setPayStatusError", e.response.data.errorMessage);
    });
    if (response) {
      const success =
        response.data.error === 0 &&
        response.status === "success" &&
        response.paySum;
      commit("setPayStatusSuccess", success);
    } else {
      commit("setPayStatusSuccess", false);
    }
  },

  async downloadCheckArt({ state, commit }, { sdate, edate, clnum }) {
    let params = {
      method: "getReport",
      params: {
        sdate: sdate,
        edate: edate,
        clientId: clnum,
        type: "caclculationsCheckAct",
        sign: true,
        accountantForm1c: true,
        format: "pdf",
      },
      deviceCid: state.deviceCid,
    };
    await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
        responseType: "blob",
      })
      .then((r) => {
        commit("setReconciliationSuccess", true);
        const href = URL.createObjectURL(r.data);
        const link = document.createElement("a");
        link.href = href;
        link.download = `checkart-${sdate}-${edate}-${clnum}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch(() => {
        commit(
          "setReconciliationError",
          "Произошла ошибка при получении документа",
        );
        commit("setReconciliationSuccess", false);
      });
  },

  async fetchDiscounts({ state, commit }, { sdate, edate, clnum }) {
    let params = {
      method: "getDiscounts",
      params: {
        sdate: sdate,
        edate: edate,
        clientId: clnum,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setDiscountsError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setDiscountsSuccess", success);
      if (success) {
        commit("setDiscounts", response.data.discounts);
      }
    } else {
      commit("setDiscountsSuccess", false);
    }
  },

  async fetchPayments({ state, commit }, { sdate, edate, clnum }) {
    let params = {
      method: "getPayments",
      params: {
        sdate: sdate,
        edate: edate,
        clientId: clnum,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setPaymentsError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setPaymentsSuccess", success);
      if (success) {
        commit("setPayments", response.data.payments);
      }
    } else {
      commit("setPaymentsSuccess", false);
    }
  },

  async fetchGroupCurrentMonthPayments({ state, commit }, { sdate }) {
    let params = {
      method: "getPayments",
      params: {
        sdate: sdate,
        clientGroup: true,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setPaymentsError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setPaymentsSuccess", success);
      if (success) {
        commit("setPayments", response.data.payments);
      }
    } else {
      commit("setPaymentsSuccess", false);
    }
  },

  async fetchBalances({ state, commit }, { sdate, edate, clnum }) {
    let params = {
      method: "getBalances",
      params: {
        sdate: sdate,
        edate: edate,
        clientId: clnum,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setBalancesError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setBalancesSuccess", success);
      if (success) {
        commit("setBalances", response.data.balances);
      }
    } else {
      commit("setBalancesSuccess", false);
    }
  },

  async fetchReports({ state, commit }, { sdate, edate, clnum }) {
    let params = {
      method: "getReports",
      params: {
        sdate: sdate,
        edate: edate,
        clientId: clnum,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setReportsError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setReportsSuccess", success);
      if (success) {
        commit("setReports", response.data.reports);
      }
    } else {
      commit("setReportsSuccess", false);
    }
  },

  async downloadReport({ state, commit }, { report_id }) {
    let params = {
      method: "getReport",
      params: {
        type: "reportById",
        id: report_id,
        sign: true,
      },
      deviceCid: state.deviceCid,
    };
    await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
        responseType: "blob",
      })
      .then((r) => {
        commit("setReportSuccess", true);
        const href = URL.createObjectURL(r.data);
        const link = document.createElement("a");
        link.href = href;
        link.download = `report-${report_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch(() => {
        commit("setReportError", "Произошла ошибка при получении документа");
        commit("setReportSuccess", false);
      });
  },

  async showReconciliation(
    { state, commit, dispatch },
    { sdate, edate, sbdate, clnum },
  ) {
    commit("setLoading", true);
    await dispatch("fetchDiscounts", {
      sdate: sdate,
      edate: edate,
      clnum: clnum,
    });
    await dispatch("fetchPayments", {
      sdate: sdate,
      edate: edate,
      clnum: clnum,
    });
    await dispatch("fetchBalances", {
      sdate: sbdate,
      edate: edate,
      clnum: clnum,
    });
    await dispatch("fetchReports", {
      sdate: sdate,
      edate: edate,
      clnum: clnum,
    });
    if (
      state.paymentsSuccess &&
      state.discountsSuccess &&
      state.balancesSuccess &&
      state.reportsSuccess
    ) {
      commit("setReconciliationSuccess", true);
    } else {
      commit(
        "setReconciliationError",
        state.discountsError ||
          state.paymentsError ||
          state.balancesError ||
          state.reportsError,
      );
    }
    commit("setLoading", false);
  },

  async fetchInvoice({ state, commit }, { clnum, advance }) {
    let params = {
      method: "makeInvoice",
      params: {
        clientId: clnum,
        advance: advance,
      },
      deviceCid: state.deviceCid,
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setInvoiceError", e.response.data.errorMessage);
      });
    if (response) {
      const success = response.data.error === 0;
      commit("setInvoiceSuccess", success);
      if (success) {
        commit("setInvoiceId", response.data.reportId);
      }
    } else {
      commit("setInvoiceSuccess", false);
    }
  },

  async downloadInvoice({ state, commit, dispatch }, { clnum, advance }) {
    await dispatch("fetchInvoice", {
      clnum: clnum,
      advance: advance,
    });
    if (state.invoiceSuccess) {
      await dispatch("downloadReport", {
        report_id: state.invoiceId,
      });
    }
    const success = state.invoiceSuccess && state.reportSuccess;
    commit("setInvoiceSuccess", success);
    if (!success) {
      commit("setInvoiceError", state.reportError);
    }
  },

  async sendFeedback({ state, commit }, { message }) {
    commit("setLoadingFeedback", true);

    let params = {
      method: "sendFeedback",
      params: { text: message },
      headers: { "IC-token": state.token },
    };
    const response = await axios
      .post(state.baseUrl, params, {
        headers: { "IC-token": state.token },
      })
      .catch((e) => {
        commit("setFeedbackError", e.response.data.errorMessage);
      });
    // const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    // await delay(3000);

    // const response = {
    //   data: {
    //     error: 0,
    //   },
    // };
    if (response) {
      //console.log(params);
      const success = response.data.error === 0;
      commit("setFeedbackSuccess", success);
    } else {
      commit("setFeedbackSuccess", false);
    }

    commit("setLoadingFeedback", false);
  },
};
